import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { GeneralContext } from "../../contexts/GeneralContext";
import { rememberLoginDestination } from "../../helpers/loginDestination";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { Authenticated, Loading, LngLink } = useContext(GeneralContext);

  return (
    <Route
      {...rest}
      render={props => {
        if (Authenticated && !Loading) {
          if (props.location.pathname === "*/") {
            return <Redirect to={LngLink + "/app"} />;
          }
          return <Component {...props} />;
        } else if (!Loading) {
          // Después del login vuelve a la cancelación si se venía de ahí (por
          // ejemplo, el botón de arrepentimiento: /app/cancel/login).
          rememberLoginDestination(props.location.pathname);
          return (
            <Redirect
              to={{
                pathname: LngLink + "/app/login"
              }}
            />
          );
        }
        return null;
      }}
    />
  );
};

export default PrivateRoute;
